import { InputWithOptionsDriver } from '../InputWithOptions/InputWithOptions.driver';

export type AutoCompleteDriver = InputWithOptionsDriver;
